export default __webpack_public_path__ + "static/bestview-grounds3-thumb-0e0714b31ec99832342c9bac2f0a85e2.jpg";